export default "__VITE_ASSET__B87BYWaF__"